/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { VideoPlayer } from '../common/video/videoPlayer.jsx';
import { smallMediaQuery, mediumMediaQuery } from '../../common/utilities/sizeHelpers';
import { convertUnixTimeStampToRelativeTime } from '../../common/utilities/dateTimeUtils';

export const MainVideoView = withScreenSize(memo(({
    currentVideoPlaylist,
    trustedPrerollUrl,
    currentVideo,
    pageId,
    platformCode,
    setCurrentVideoInfo,
    onNewVideoStarted,
    onVideoPaused,
    onVideoStopped,
    onVideoCompleted,
    onVideoViewed,
    muteByDefault,
    videoPrerollAdClient,
    featuredVideoPrerollPlacementId,
    currentVideoDescription,
    currentVideoPublishDate
}) => {
    let timeCaption = '';
    if (currentVideoPublishDate) {
        // N.B currentVideoPublishDate timestamp is in seconds - required in Milliseconds.
        const currentVideoTimeStampInMilliSeconds = currentVideoPublishDate * 1000;
        timeCaption = convertUnixTimeStampToRelativeTime(currentVideoTimeStampInMilliSeconds) ?? '';
    }

    return (
             
        <MainVideo>
            {
                currentVideoPlaylist 
                    ? <>
                        {trustedPrerollUrl 
                            && <VideoPlayer
                                posterImageUrl={currentVideo.poster}
                                adPageId={pageId}
                                platformCode={platformCode}
                                playlist={currentVideoPlaylist}
                                height={'auto'}
                                playlistNextCallback={setCurrentVideoInfo}
                                onVideoStarted={onNewVideoStarted}
                                onPause={onVideoPaused}
                                onStop={onVideoStopped}
                                onVideoCompleted={onVideoCompleted}
                                onVideoViewed={onVideoViewed}
                                muteByDefault={muteByDefault}
                                adUrl={trustedPrerollUrl}
                                adFormat={videoPrerollAdClient}
                                placementId={featuredVideoPrerollPlacementId}
                            />
                        }
                        <ThumbDescription>
                            <VideoTitle>
                                {currentVideoDescription}
                            </VideoTitle>
                            <TimeCaption>
                                {currentVideo ? timeCaption : ''}
                            </TimeCaption>
                        </ThumbDescription>
                    </>
                    : null
            }
        </MainVideo>
    );
}));

MainVideoView.displayName = 'MainVideoView';
MainVideoView.propTypes = {
    currentVideoPlaylist: PropTypes.array,
    prerollUrl: PropTypes.string,
    currentVideo: PropTypes.object,
    pageId: PropTypes.string,
    platformCode: PropTypes.string,
    setCurrentVideoInfo: PropTypes.any,
    onNewVideoStarted: PropTypes.any,
    onVideoPaused: PropTypes.any,
    onVideoStopped: PropTypes.any,
    onVideoCompleted: PropTypes.any,
    onVideoViewed: PropTypes.any,
    muteByDefault: PropTypes.any,
    currentVideoDescription: PropTypes.string,
    currentVideoPublishDate: PropTypes.number,
    videosIsFetching: PropTypes.any
};

const VideoTitle = styled.h1`
    display: flex;
    margin: 0;
    font: inherit;
`;

const MainVideo = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 24px -5px;
    min-width: calc(100% - 316px);
    width: calc(100% - 316px);
    min-height: 600px;

    @media ${mediumMediaQuery} {
        min-width: 600px;
        width: 608px;
        min-height: 425px;
    }
    @media ${smallMediaQuery} {
        min-width: 250px;
        min-height: 270px;
        width: 80%;
        margin-left: 10%;
    }
`;

const TimeCaption = styled.div`
    color: #555555;
    font-size: 16px;
    font-weight: 200;
`;

const ThumbDescription = styled.div`
    background-color: #f9f9f9;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
    padding: 12px 16px;
    height: 84px;
`;
